// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import Vuex from "vuex";
import CardNames from "./card-names";

Vue.use(Vuex);

Vue.config.productionTip = false;
Vue.directive("translatecard", {
  bind: function(el, binding, vnode) {
    el.innerHTML = CardNames[binding.value];
  }
});

Vue.prototype.$eventHub = new Vue(); // Global event bus

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js